import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-email-change-verification-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './email-change-verification.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class EmailChangeVerificationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<EmailChangeVerificationTemplateData>;
}

export type EmailChangeVerificationTemplateData = {
  title: string;
  p1: string;
  p2_html: string;
  p3: string;
  avatar_url: string;
  footer: string;
  support_email: string;
};

export const EmailChangeVerificationTemplateMocks: EmailChangeVerificationTemplateData[] = [
  {
    title: 'Verify your email address',
    p1: 'Hi Olivia! 👋 Please click on the link below to verify your email address for Recruitee.',
    p2_html: '<a href="http://recruitee.com">http://recruitee.com</a>',
    p3: "If you didn't update it, you can ignore this email.",
    avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
    footer: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
